import { IMarkupProfileStoreSegment } from './markupProfile.interface';

export const markupProfileStoreSelector = (state: IMarkupProfileStoreSegment) => state.markupProfile;
